import axios from "../axiosConfig";
import { ENDPOINT_FORGOT_REQUEST, ENDPOINT_FORGOT_VALIDATE, ENDPOINT_FORGOT_UPDATE } from "../../constants";

// add this new functions
export const forgotPassword = async (email: string) => {
    const res = await axios.post(ENDPOINT_FORGOT_REQUEST, { email });
    return res.data.Code;
};

export const validateForgot = async (code: string) => {
    const res = await axios.post(ENDPOINT_FORGOT_VALIDATE, { code });
    const data = res.data;
    return data;
};

export const updatePassword = async (code: string, username:string, pass: string) => {
    username = btoa(username)
    pass = btoa(pass)
    const res = await axios.post(ENDPOINT_FORGOT_UPDATE, { code, pass, username });
    const data = res.data;
    return data.Code;
};
